import { BaseComponent } from "../BaseComponent";

import { Type } from "@angular/compiler";
import { ComponentNames } from 'src/app/helper/componentNames';

export class PlacingRestrictorComponent extends BaseComponent{
    constructor(){
        super();
        this.componentType = ComponentNames.placingRestrictorComponent;
    }
    notIn:Array<Type>;
}